import { MobileTheme } from '@map/theme/types';
import { useTheme as muiUseTheme } from '@mui/material/styles';
import baseMakeStyles, { CustomMakeStyles } from '@shared/theme/makeStyles';
import baseStyled, { CustomStyled } from '@shared/theme/styled';

export const makeStyles = baseMakeStyles as CustomMakeStyles<MobileTheme>;

export const styled = baseStyled as CustomStyled<MobileTheme>;

export const useTheme = muiUseTheme as () => MobileTheme;

export { default as buildTheme } from './buildTheme';
